/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { Plate } from "src/classes/plate/Plate";
import { FileUtils } from "src/classes/utilities/FileUtils";

export function SyncStatusAlertInfo({ plate }: { plate: Plate }) {
  const isConnected = plate.socket.observe((state) => state.connected);
  const awaitingReceipts = plate.socket.observe((state) => state.awaitingReceipt);
  const awaitingSend = plate.socket.observe((state) => state.awaitingSend);

  return (
    <StyledSyncStatusInfo>
      <div>Connected: {isConnected ? "true" : "false, retrying..."}</div>
      <div>
        Changes in transit: {awaitingReceipts.length}
        {awaitingReceipts.length
          ? `, size: ${FileUtils.getReadableFileSizeFromBytes(
              awaitingReceipts.reduce((acc, cur) => acc + cur.size, 0)
            )}`
          : ""}
      </div>
      <div>About to send: {awaitingSend}</div>
      <div>Total unsaved: {awaitingSend + awaitingReceipts.length}</div>
    </StyledSyncStatusInfo>
  );
}

const StyledSyncStatusInfo = styled.div`
  margin-top: 15px;
  margin-bottom: 10px;
`;
